"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersAutoComplete = exports.AutoCompleteItem = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const lodash_es_1 = require("lodash-es");
const react_1 = require("react");
const useCustomer_1 = require("../api/useCustomer");
const useForties_1 = require("../api/useForties");
const useDebounce_1 = tslib_1.__importDefault(require("../hooks/useDebounce"));
const Actors_1 = require("../types/Actors");
const MemberItem_1 = require("./MemberItem");
const AutoCompleteItem = ({ actor, type }) => {
    const { name, email } = (0, Actors_1.generateActorInfo)(type, actor);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MemberItem_1.MemberItem, { idType: type, actor: actor, disabled: true, displayName: false }), (0, jsx_runtime_1.jsx)(silhouette_core_1.ListItemText, { primary: name, secondary: email })] }));
};
exports.AutoCompleteItem = AutoCompleteItem;
const MembersAutoComplete = ({ subscription, addSubscriber, subscriptionType, customerID, }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const [searchKey, setSearchKey] = (0, react_1.useState)('');
    const [forties, setForties] = (0, react_1.useState)([]);
    const [userList, setUserList] = (0, react_1.useState)([]);
    const debouncedSearchQuery = (0, useDebounce_1.default)(searchKey);
    const fortieData = (0, useForties_1.useForties)(subscriptionType, debouncedSearchQuery);
    const customerUserData = (0, useCustomer_1.useCustomerUsers)(customerID);
    (0, react_1.useEffect)(() => {
        if (fortieData.isSuccess) {
            setForties(fortieData.data);
        }
    }, [fortieData.data, fortieData.isSuccess]);
    (0, react_1.useEffect)(() => {
        if (customerUserData.isSuccess) {
            setUserList(customerUserData.data);
        }
    }, [customerUserData.data, customerUserData.isSuccess]);
    const { subscriptions } = subscription;
    const getOptions = () => {
        const userOptions = userList
            ?.filter((user) => !(0, lodash_es_1.find)(subscriptions[0]?.externalUserIds, (userId) => user.id === userId))
            .map((user) => ({
            label: (0, Actors_1.getCustomerUserName)(user),
            value: user.id,
            actor: user,
            type: Actors_1.USER_ID,
        })) || [];
        const fortieOptions = forties
            ?.filter((fortie) => !(0, lodash_es_1.find)(subscriptions[0]?.internalUserIds, (fortieId) => fortie.id === fortieId))
            .map((fortie) => ({
            label: fortie.name || '',
            value: fortie.id,
            actor: fortie,
            type: Actors_1.FORTIE_ID,
        })) || [];
        return [...userOptions, ...fortieOptions];
    };
    const handleSubscriberSelection = (_, selection) => {
        if (selection) {
            const { value, type } = selection;
            addSubscriber(value, type);
        }
    };
    const onInputChange = (_, value) => {
        if (value.length > 1)
            setSearchKey(value);
    };
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Autocomplete, { onInputChange: onInputChange, options: getOptions(), className: "basic-multi-select", renderOption: exports.AutoCompleteItem, onChange: handleSubscriberSelection, label: translate('members-auto-complete_select_subscriber'), noOptionsText: translate('members-auto-complete-no_options'), getOptionLabel: (option) => option.label || '' }));
};
exports.MembersAutoComplete = MembersAutoComplete;
//# sourceMappingURL=MembersAutoComplete.js.map